class printFormatMock {
    values = [
        { id: 1, nombre: "A4" },
        { id: 2, nombre: "TICKET (80 mm)" },
        { id: 3, nombre: "TICKET (57 mm)" }
    ];
}
export default new printFormatMock();